<script>
	export let weight;
	export let uom; // = "kg";
	$: time = uom=="kg"?(2.205 * weight)*20+20:weight*20+20;
	$: hours = calc_hours(time);

	function calc_hours(t) {
		let mins = t % 60;
		let hours = (t - mins) / 60;
		if(hours > 0) {
			return `${hours} hour${hours!=1?"s":""} ${mins!=0?` ${Math.round(mins)} mins`:""}`;
		} else {
			return `${Math.round(mins)} mins`;
		}
	}
</script>

<main>
	<h1>🐔</h1>
	<h2>Chicken weight:</h2>
	<input type=number bind:value={weight} min=0 max=10 step="0.1"> {uom}
	<label>
	<input type=radio bind:group={uom} value={"kg"}>	
	Kilograms
	</label>

	<label>
		<input type=radio bind:group={uom} value={"lb"}>
		Pounds (lb) 
	</label>
	<p class="results">Cooking Time: {hours}</p>
	<p>Cook at 180°C</p>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}
	.results {
		font-weight: bold;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>